import './styles/main.scss'
import App from '@/modules/App'

const app = new App()

export {
  app
}
